import { render, staticRenderFns } from "./StudentInvite.vue?vue&type=template&id=4b943f9e&scoped=true"
import script from "./StudentInvite.vue?vue&type=script&lang=js"
export * from "./StudentInvite.vue?vue&type=script&lang=js"
import style0 from "./StudentInvite.vue?vue&type=style&index=0&id=4b943f9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b943f9e",
  null
  
)

export default component.exports